export default __webpack_public_path__ + "static/media/blog_sample1.91216ebe.png";